import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { Box } from '@mui/material';

const loadingAnimation = keyframes`
  from, 20% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  80%, 100% {
    opacity: 0;
  }
`;

export const StyledBox = styled(Box)`
  background-color: white;
  width: 100%;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  transform: translateX(-50%);
  left: 50%;
  position: absolute;
  outline: none;

  @media (min-width: 600px) {
    width: calc(100% - var(--spacing-32));
    max-width: 620px;
    height: calc(100dvh - 2 * var(--spacing-32));
    max-height: 680px;
    top: var(--spacing-32);
    border-radius: var(--border-radius-l);
  }
`;

export const Header = styled.header`
  display: flex;
  padding: var(--spacing-16);
  align-items: center;
  gap: var(--spacing-16);

  @media (min-width: 600px) {
    padding-left: var(--spacing-24);
    padding-right: var(--spacing-24);
  }
`;

export const Text = styled.span`
  flex: 1;
  font: var(--font-body-l-bold);
`;

export const Footer = styled.footer`
  padding: var(--spacing-24) var(--spacing-16);
`;

export const Chat = styled.section`
  background: var(--sembo-inspire-s-color-background-primary);
  padding: var(--spacing-24);
  overflow: auto;
  flex: 1 0 0;

  & > * + * {
    margin-top: var(--spacing-40);
  }
`;

export const DotsWrapper = styled.div`
  display: flex;
  width: fit-content;
  background-color: white;
  padding: var(--spacing-16);
  border-radius: 10px;
  margin-top: var(--spacing-8);
`;
